import { render, staticRenderFns } from "./exhibition-release-new-all.vue?vue&type=template&id=b6a02f32&scoped=true&"
import script from "./exhibition-release-new-all.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new-all.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-release-new-all.vue?vue&type=style&index=0&id=b6a02f32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a02f32",
  null
  
)

export default component.exports